import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import men from '../../assets/images/men.svg'; // Update path as needed

const ContactFormSection = ({ apiEndpoint }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    reason: '',
    message: '',
    agree: false,
  });

  const [validated, setValidated] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity() || !formData.agree) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

        const responseData = await response.json();
      if (response.ok && responseData.status) {
        setSuccessMessage(responseData.message || 'Your message has been sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          reason: '',
          message: '',
          agree: false,
        });
        setValidated(false);
      } else {
        setSuccessMessage(responseData.message || 'Submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      setSuccessMessage('Error submitting the form. Please try again later.');
    }
    setLoading(false);
  };

  return (
    <section className="contact-section">
      <Container>
        <Row className="align-items-center">
          {/* Form Side */}
          <Col lg={6} md={12} className="mb-4">
            <h2 className="left-about-content-home">
              Let’s Talk About Your Next Big Move
              <span className="orange-dot">.</span>
            </h2>
            <p className="right-about-content-home">
              From strategy to execution, we help organizations unlock value through technology.
              Tell us what you need — we’re listening and ready to deliver.
            </p>

            {successMessage && (
              <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible>
                {successMessage}
              </Alert>
            )}

            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide your first name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide your last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid email.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone *</Form.Label>
                   <Form.Control
  type="tel"
  name="phone"
  value={formData.phone}
  onChange={handleChange}
  pattern="[0-9]{10}"
  minLength={10}
  maxLength={15}
  required
/>
<Form.Control.Feedback type="invalid">
  Please enter a valid phone number.
</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Reason for Inquiry *</Form.Label>
                <Form.Control
                  type="text"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a reason for inquiry.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Message *</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a message.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                    label={
                      <>
                        I agree to CloudKodeForm’s privacy terms. <br />
                        <small>You can read our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</small>
                      </>
                    }
                    required
                    feedback="You must agree before submitting."
                    feedbackType="invalid"
                  />
                </Form.Group>

              <Button className="me-3 ckf-button-dark" type='submit' disabled={loading}>
                 {loading ? 'Sending...' : 'Book A Consultation'} &nbsp;
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="13"
                                viewBox="0 0 24 13"
                              >
                                <path
                                  className="cloud_point_white"
                                  d="M19.64,4.62h-.3a4.09,4.09,0,0,0-4.07-3.31,4.17,4.17,0,0,0-2.49.81A4.39,4.39,0,0,0,9,0,4.28,4.28,0,0,0,4.63,4.19a3.25,3.25,0,0,0,0,.44h-.3A4.27,4.27,0,0,0,0,8.81,4.28,4.28,0,0,0,4.36,13H19.64A4.28,4.28,0,0,0,24,8.81,4.27,4.27,0,0,0,19.64,4.62Z"
                                  transform="translate(0)"
                                />
                              </svg>
                            </Button>
            </Form>
          </Col>

          {/* Image Side */}
          <Col lg={6} md={12} className="text-center">
            <img
              src={men}
              alt="Man with Laptop"
              className="img-fluid contact-img"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactFormSection;
